import React, { useState, useEffect, useMemo, useRef } from "react";
import Export from "./components/Export";
import "./index.css";
import printJS from "print-js";
import Select from "react-select";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../../components/InitialPrompt";
import CustomSelect from "../../../../components/CustomSelect";
import PageHeader from "../../../../components/PageHeader";
import CustomNativeSelect from "../../../../components/CustomNativeSelect";
import MonthSelector from "../../../../components/MonthSelector";
import YearSelector from "../../../../components/YearSelector";
import ExcelJS from "exceljs";

function MonthlySalesChartPage({
  objects,
  onChangeDate,
  onChangeStore,
  dateField,
  store,
  storess,
  progress,
  notFound,
}) {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [optionss, setOptionss] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [filterBox, setFilterBox] = useState(false);
  const chartRef = useRef(null);
  const [selectedMonthName, setSelectedMonthName] = useState("");
  const [range, setRange] = useState("");
  const final = objects;
  console.log(
    "asdasd",
    final
      ?.filter((obj) => obj.status === "C")
      .reduce((sum, obj) => sum + parseFloat(obj.total || 0), 0),
    final,
  );

  useEffect(() => {
    processData();
  }, [objects]);

  const processData = () => {
    const data = objects;

    const storeCodes = data?.reduce((acc, item) => {
      const code = item.store_code.split("ANGELSPIZZA_")[1]; // Remove prefix
      if (code && !acc.includes(code)) {
        acc.push(code);
      }
      return acc;
    }, []);

    setOptionss(storeCodes?.map((code) => ({ value: code, label: code })));
  };

  const onChangeType = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // Pre-process ung objects para sa date parsing
  // Modify the useMemo that processes the objects
  const parsedObjects = useMemo(() => {
    return objects
      ?.filter((obj) => obj.status === "C")
      ?.map((obj) => {
        const parts = obj.store_code.split("ANGELSPIZZA_");
        const codePart = parts.length > 1 ? parts[1] : ""; // Get the part after 'ANGELSPIZZA_'
        return {
          ...obj,
          parsedMonth: new Date(obj.tran_date).toLocaleString("default", {
            month: "long",
          }),
          parsedYear: new Date(obj.tran_date).getFullYear().toString(),
          storeCodePart: codePart,
        };
      });
  }, [objects]);

  // Update filtered data when selections change
  useEffect(() => {
    const filtered = parsedObjects?.filter((obj) => {
      const matchesMonth = selectedMonthName
        ? obj.parsedMonth ===
          (selectedMonth === "AllMonths" ? selectedMonth : selectedMonthName)
        : true;
      const matchesYear = selectedYear ? obj.parsedYear === selectedYear : true;
      const matchesOption = selectedOption
        ? obj.storeCodePart === selectedOption // Compare using the new storeCodePart
        : true;
      return matchesMonth && matchesYear && matchesOption;
    });
    setFilteredData(filtered);
  }, [
    parsedObjects,
    selectedMonth,
    selectedYear,
    selectedOption,
    selectedMonthName,
  ]);

  const calculateGrowthPercentage = (salesData) => {
    let previousMonthSales = null;
    let growthPercentages = {};

    Object.entries(salesData).forEach(([monthYear, data], index) => {
      if (previousMonthSales !== null && previousMonthSales !== 0) {
        const growthPercentage =
          ((data.sales - previousMonthSales) / previousMonthSales) * 100;
        growthPercentages[monthYear] = growthPercentage;
      }
      previousMonthSales = data.sales;
    });

    return growthPercentages;
  };

  const salesData = useMemo(() => {
    const result = final
      ?.filter((obj) => obj.status === "C")
      .reduce((acc, obj) => {
        const parsedMonth = new Date(obj.tran_date).toLocaleString("default", {
          month: "long",
        });
        const parsedYear = new Date(obj.tran_date).getFullYear().toString();
        const monthYear = `${parsedMonth} ${parsedYear}`;

        // Safely parse total and tax
        const total = parseFloat(obj.total ?? 0);
        // const tax = parseFloat(obj?.total_tax) || 0;

        if (!acc[monthYear]) {
          acc[monthYear] = { sales: 0 };
        }

        acc[monthYear].sales += total;
        return acc;
      }, {});

    return result;
  }, [final]);

  const growthPercentages = useMemo(
    () => calculateGrowthPercentage(salesData),
    [salesData],
  );

  // Preparing chart data
  const chartLabels = Object.keys(salesData);
  const chartSalesData = Object.values(salesData).map((data) => data.sales);
  const chartGrowthData = chartLabels.map(
    (label) => growthPercentages[label] || 0,
  );

  const data = {
    labels: chartLabels.reverse(),
    datasets: [
      {
        type: "bar", // Bar chart for sales
        label: "Monthly Sales",
        data: chartSalesData,
        backgroundColor: ["#006096"],
        borderColor: ["#006096"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        beginAtZero: true,
      },
    },

    plugins: {
      datalabels: {
        color: "#FFF",
        anchor: "center",
        align: "center",
        font: {
          size: 20,
        },
        formatter: (value, context) => {
          return value.toLocaleString();
        },
      },
    },
  };

  const handleMonthChange = (selectedOption) => {
    if (!selectedOption) return;

    setSelectedMonth(selectedOption.value);
    setRange(selectedOption.value);

    const parsedValue = JSON.parse(selectedOption.value);
    onChangeDate(parsedValue);

    // Set month name from the label
    setSelectedMonthName(selectedOption.label);
  };

  const handleYearChange = (selectedOption) => {
    if (!selectedOption) return;

    const year = selectedOption.value;

    // Assuming 'range' is a JSON string that needs to be parsed
    let parsedRange = JSON.parse(range);

    // Get the month from the $gte date to determine if it's December
    const gteMonth = parsedRange.$gte.substring(5, 7);
    const isDecember = gteMonth === "12";

    // Update $gte with the new year
    parsedRange.$gte =
      year + parsedRange.$gte.substring(parsedRange.$gte.indexOf("-"));

    // For $lte, if it's December, the end date should be in the next year
    if (isDecember) {
      const nextYear = (parseInt(year) + 1).toString();
      parsedRange.$lte =
        nextYear + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));
    } else {
      parsedRange.$lte =
        year + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));
    }

    // Update selectedMonth with the new date range so it stays selected
    setSelectedMonth(JSON.stringify(parsedRange));
    setRange(JSON.stringify(parsedRange));
    setSelectedYear(year);
    onChangeDate(parsedRange);
  };

  const months = useMemo(() => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Use current year as default if selectedYear is not set
    const year = selectedYear || new Date().getFullYear().toString();

    const monthsFormatted = monthNames.map((name, index) => {
      const monthNumber = (index + 1).toString().padStart(2, "0");
      // Business date starts at 5:00 AM on the 1st of the month
      const firstDayOfMonth = `${year}-${monthNumber}-01T05:00:00.000Z`;

      // Business date ends at 4:59 AM on the 1st of the next month
      const nextMonthIndex = index + 1;
      const nextMonthYear = nextMonthIndex === 12 ? parseInt(year) + 1 : year;
      const nextMonthNumber = (nextMonthIndex === 12 ? 1 : nextMonthIndex + 1)
        .toString()
        .padStart(2, "0");
      const lastDayOfMonth = `${nextMonthYear}-${nextMonthNumber}-01T04:59:59.999Z`;

      return {
        name, // The display name of the month
        createdAt: {
          $gte: firstDayOfMonth,
          $lte: lastDayOfMonth,
        },
      };
    });

    return monthsFormatted;
  }, [selectedYear]);

  const years = useMemo(() => {
    return Array.from(
      new Set(objects?.map((obj) => new Date(obj.createdAt).getFullYear())),
    );
  }, [objects]);

  // function convertToCSV(objArray) {
  //   const array =
  //     typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  //   let str =
  //     `${Object.keys(array[0])
  //       .map((value) => `"${value}"`)
  //       .join(",")}` + "\r\n";

  //   for (let i = 0; i < array.length; i++) {
  //     let line = "";
  //     for (let index in array[i]) {
  //       if (line !== "") line += ",";

  //       line += `"${array[i][index]}"`;
  //     }

  //     str += line + "\r\n";
  //   }

  //   return str;
  // }

  // const exportToCSV = () => {
  //   const csvData = [];
  //   Object.entries(salesData).forEach(([monthYear, data]) => {
  //     csvData.push({
  //       brand: "Angels Pizza",
  //       store: storess,
  //       monthYear,
  //       sales: data.sales,
  //     });
  //   });

  //   const csvString = convertToCSV(csvData);
  //   const a = document.createElement("a");
  //   const blob = new Blob([csvString], { type: "text/csv" });
  //   const url = window.URL.createObjectURL(blob);

  //   a.href = url;
  //   a.download = "monthly-sales-data.csv";
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // };

  const exportTransactionsToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    const transactions = final?.filter((obj) => obj.status === "C");

    // Set workbook properties
    workbook.creator = "Angels Pizza Analytics";
    workbook.created = new Date();
    workbook.modified = new Date();

    const worksheet = workbook.addWorksheet("Transactions", {
      properties: { tabColor: { argb: "FF83c14a" } },
      views: [{ state: "frozen", xSplit: 0, ySplit: 1 }], // Freeze header row
    });

    // Add title row
    worksheet.mergeCells("A1:F1");
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "ANGELS PIZZA - Monthly Gross Sales";
    titleCell.font = {
      name: "Calibri",
      size: 16,
      bold: true,
      color: { argb: "FF83c14a" },
    };
    titleCell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getRow(1).height = 35;

    // Add metadata row
    worksheet.mergeCells("A2:F2");
    const metaCell = worksheet.getCell("A2");
    metaCell.value = `Generated on: ${new Date().toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })} | Total Transactions: ${transactions.length}`;
    metaCell.font = {
      name: "Calibri",
      size: 10,
      italic: true,
      color: { argb: "FF666666" },
    };
    metaCell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getRow(2).height = 20;

    // Empty row for spacing
    worksheet.addRow([]);

    // Add header row manually at row 4
    const headerRow = worksheet.getRow(4);
    headerRow.values = [
      "Transaction ID",
      "Status",
      "Store",
      "Date & Time",
      "Total (₱)",
    ];

    // Define column widths
    worksheet.columns = [
      { key: "tran_id", width: 18 },
      { key: "status", width: 12 },
      { key: "store_code", width: 35 },
      { key: "tran_date", width: 22 },
      { key: "total", width: 18 },
    ];

    // Style header row
    headerRow.height = 30;
    headerRow.font = {
      name: "Calibri",
      size: 12,
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF83c14a" },
    };
    headerRow.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "medium", color: { argb: "FF000000" } },
        bottom: { style: "medium", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });

    // Add data rows (starting from row 5)
    transactions.forEach((transaction, index) => {
      const rowNumber = 5 + index;
      const row = worksheet.getRow(rowNumber);

      row.values = [
        transaction.tran_id,
        transaction.status,
        transaction.store_code,
        new Date(transaction.tran_date),
        parseFloat(transaction.total),
      ];

      // Alternate row colors
      const isEvenRow = index % 2 === 0;
      row.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: isEvenRow ? "FFFFFFFF" : "FFF8FAFB" },
      };

      row.height = 22;

      // Style each cell
      row.eachCell((cell, colNumber) => {
        cell.font = {
          name: "Calibri",
          size: 11,
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FFE5E7EB" } },
          bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
          left: { style: "thin", color: { argb: "FFE5E7EB" } },
          right: { style: "thin", color: { argb: "FFE5E7EB" } },
        };

        // Column-specific styling
        switch (colNumber) {
          case 1: // Transaction ID
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.font = { ...cell.font, color: { argb: "FF3b82f6" } };
            break;
          case 2: // Status
            cell.alignment = { vertical: "middle", horizontal: "center" };
            // Style based on status
            if (transaction.status === "C") {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFD4EDDA" }, // Light green
              };
              cell.font = {
                ...cell.font,
                bold: true,
                color: { argb: "FF155724" },
              };
              cell.value = "C";
            } else if (transaction.status === "P") {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFF3CD" }, // Light yellow
              };
              cell.font = {
                ...cell.font,
                bold: true,
                color: { argb: "FF856404" },
              };
              cell.value = "P";
            } else if (transaction.status === "X") {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFF8D7DA" }, // Light red
              };
              cell.font = {
                ...cell.font,
                bold: true,
                color: { argb: "FF721C24" },
              };
              cell.value = "X";
            }
            break;
          case 3: // Store
            cell.alignment = { vertical: "middle", horizontal: "left" };
            break;
          case 4: // Date & Time
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.numFmt = "yyyy-mm-dd hh:mm:ss";
            break;
          case 5: // Total
            cell.alignment = { vertical: "middle", horizontal: "right" };
            cell.numFmt = "₱#,##0.00";
            break;
          case 6: // Tax
            cell.alignment = { vertical: "middle", horizontal: "right" };
            cell.numFmt = "₱#,##0.00";
            break;
        }
      });
    });

    // Add summary section
    const summaryRowNumber = 5 + transactions.length;
    worksheet.addRow([]); // Empty row

    // Calculate totals
    const totalAmount = transactions.reduce(
      (sum, t) => sum + parseFloat(t.total || 0),
      0,
    );
    const totalTax = transactions.reduce(
      (sum, t) => sum + parseFloat(t.total_tax || 0),
      0,
    );

    // Total row
    const totalRowNumber = summaryRowNumber + 1;
    const totalRow = worksheet.getRow(totalRowNumber);
    totalRow.values = ["", "", "", "", totalAmount, totalTax];

    // Merge cells for "TOTAL" label
    worksheet.mergeCells(`A${totalRowNumber}:D${totalRowNumber}`);
    const totalLabelCell = worksheet.getCell(`A${totalRowNumber}`);
    totalLabelCell.value = "TOTAL";
    totalLabelCell.alignment = { vertical: "middle", horizontal: "right" };
    totalLabelCell.font = {
      name: "Calibri",
      size: 13,
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    totalLabelCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF6fad3e" },
    };

    totalRow.height = 28;
    totalRow.eachCell((cell) => {
      cell.font = {
        name: "Calibri",
        size: 13,
        bold: true,
        color: { argb: "FFFFFFFF" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF6fad3e" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "right",
      };
      cell.border = {
        top: { style: "medium", color: { argb: "FF000000" } },
        bottom: { style: "medium", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });

    // Format total cells as currency
    totalRow.getCell(5).numFmt = "₱#,##0.00";
    totalRow.getCell(6).numFmt = "₱#,##0.00";

    // Generate and download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `angels-pizza-monthly-gross-sales-${new Date().toISOString().split("T")[0]}.xlsx`;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const formatSales = (sales) => {
    return sales?.toLocaleString("en-US", {
      style: "currency",
      currency: "PHP",
    });
  };

  const printChart = () => {
    setTimeout(() => {
      printJS({
        printable: "chart-container",
        type: "html",
        header: `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                   <img src="/figaro.png" alt="Figaro" style="height: 50px;"/>
                   <h4 style="margin: 0 auto;">FIGARO COFFEE GROUP</h4>
                   <img src="/angels.png" alt="Angel's Pizza" style="height: 50px;"/>
                 </div>`,
        css: "./index.css",
        scanStyles: false,
        style: ".print-only-content { display: block; }",
      });
    }, 500);
  };

  const totalSales = final
    ?.filter((obj) => obj.status === "C")
    .reduce((sum, obj) => sum + parseFloat(obj.total || 0), 0);

  const highchartsOptions = {
    chart: {
      type: "column",
    },
    title: {
      text: "Total Gross Sales",
    },
    xAxis: {
      categories: ["Total Gross Sales"],
    },
    yAxis: {
      title: {
        text: " Gross Sales (PHP)",
      },
      labels: {
        formatter: function () {
          return "₱" + this.value.toLocaleString();
        },
      },
    },
    tooltip: {
      valuePrefix: "₱",
      valueDecimals: 2,
    },
    series: [
      {
        name: "Gross Sales",
        data: [totalSales],
        color: "#006096",
      },
    ],
    credits: {
      enabled: false, // 👈 This removes the watermark
    },
  };
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <PageHeader
          title="Monthly Gross Sales Chart"
          subtitle="Track your revenue trends and performance over time"
          icon="bi bi-calendar-month"
        />
        <Export exportCsv={exportTransactionsToExcel} exportPdf={printChart} />
      </div>
      {/* Chart Component */}
      <div className="row mb-2">
        <div className="col-sm-4">
          <CustomSelect
            label="Store"
            options={[
              // { value: "AllStore", label: "All Store" },
              ...store.map((store) => ({
                value: store.name,
                label: store.name.replace(/_/g, " "),
              })),
            ]}
            onChange={(selected) => onChangeStore(selected.value)}
            // isDisabled={range}
            // error={range ? "Please select a date range first" : ""}
            icon="bi bi-shop"
            placeholder="Select Store"
            isClearable={true}
          />
        </div>

        <div className="col-sm-6 col-lg-3">
          <MonthSelector
            months={months}
            selectedMonth={selectedMonth}
            onChange={handleMonthChange}
          />
        </div>

        <div className="col-sm-6 col-lg-3">
          <YearSelector
            selectedYear={selectedYear}
            onChange={handleYearChange}
            yearsCount={5}
          />
        </div>
      </div>

      {!selectedYear && <InitialPrompt twoFilter={false} />}

      {notFound && (
        <div className="text-center mt-5">
          <p className="text-muted fs-5">
            📭 Data not found for selected filter.
          </p>
        </div>
      )}

      {objects?.length === 0 &&
        storess &&
        selectedMonthName &&
        selectedYear &&
        !notFound && (
          <div div className="text-center mt-5">
            <DefaultState />
          </div>
        )}

      {
        // !progress &&
        objects?.length > 0 && storess && selectedMonthName && selectedYear && (
          <div ref={chartRef} id="chart-container">
            <div className="card">
              <HighchartsReact
                highcharts={Highcharts}
                options={highchartsOptions}
              />
            </div>
            <div className="print-only-content">
              <h2>Report Details</h2>
              <div className="d-flex justify-content-between align-items-center print-only-content">
                <h3>Brand: Angels Pizza</h3>
                <h4 className="mx-auto"></h4>
                <h3>Store: {storess}</h3>
              </div>
              <div className="print-only" style={{ fontSize: "20px" }}>
                <table className="table text-center">
                  <thead>
                    <tr className="d-flex">
                      <th>Month</th>
                      <th className="ms-5">Gross Sales</th>
                    </tr>{" "}
                  </thead>
                  <tbody>
                    {data.labels.map((label, index) => (
                      <tr className="d-flex" key={label}>
                        <td>{label}</td>
                        <td>{formatSales(data.datasets[0].data[index])}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
}

export default MonthlySalesChartPage;
